export const operatorsWithLabels = [
  {
    value: ">",
    label: "greater than",
  },
  {
    value: "<",
    label: "less than",
  },
  {
    value: "=",
    label: "is",
  },
  {
    value: "!=",
    label: "is not",
  },
  {
    value: "between",
    label: "is between",
  },
  // {
  //   value: ">=",
  //   label: "greater than or equal to",
  // },
  // {
  //   value: "<=",
  //   label: "less than or equal to",
  // },
]
